export class ActivateAccountRequest {
  email: string;
  password: string;
  token: string;
  confirmPassword?: string;

  constructor(email: string, password: string, token: string) {
    this.email = email;
    this.password = password;
    this.token = token;
  }
}
